<template>
  <el-form :inline="true" class="mainSearch">
    <el-page-header @back="goback" style="margin-bottom: 20px">
      <template #content>
        <span class="text-large font-600 mr-3">{{ title }} </span>
      </template>
    </el-page-header>
  </el-form>
  <el-row class="mainTableBox">
    <el-col :span="24" class="mpadding">
      <template v-for="(item, index) in goodsSuppliers" :key="item">
        <el-descriptions
          :title="'供应商信息（' + (index + 1) + ')'"
          :column="1"
        >
          <el-descriptions-item label="供应商"
            ><span v-text="item.supplier.name"></span
          ></el-descriptions-item>
          <el-descriptions-item label="供应商商品ID"
            ><span v-text="item.sgoodsnum"></span
          ></el-descriptions-item>
          <el-descriptions-item label="成本价">
            <span v-if="item.costprice" v-text="(item.costprice).toFixed(2)" />
            </el-descriptions-item>
          <el-descriptions-item label="市场价">
            <span v-if="item.marketprice" v-text="(item.marketprice).toFixed(2)" /></el-descriptions-item>
          <el-descriptions-item label="销售价">
            <span v-if="item.saleprice" v-text="(item.saleprice).toFixed(2)" />
          </el-descriptions-item>
          <el-descriptions-item label="商品折扣">
            <span v-if="item.discount" v-text="(item.discount*100).toFixed(2) + '%'" />
          </el-descriptions-item>
          <el-descriptions-item label="货源状态">
            <el-tag
              round
              :type="item.status === 1 ? 'success' : 'danger'"
              disable-transitions
              ><span v-text="util.showGoodsStatus(item.status)"></span
            ></el-tag>
          </el-descriptions-item>
        </el-descriptions>
        <el-divider />
      </template>
    </el-col>
  </el-row>
</template>
<script setup>
import { useRouter } from "vue-router";
import { ref, onMounted } from "vue";
import { getGoodsInfo } from "@/api/goods";
import util from "@/util/tool.js";

const router = useRouter();

const goodsid = ref(router.currentRoute.value.params.id);
const title = ref();

const goodsSuppliers = ref([]);
//返回
const goback = () => {
  router.go(-1);
};

//onMounted方法
onMounted(() => {
  //详情
  getGoodsInfo({ goodsid: goodsid.value }).then((res) => {
    let data = res.data.extend.goods;
    title.value = data.name
    let goodsSuppliersTmp = data.goodsSuppliers;
    let dataTmp = [];
    goodsSuppliersTmp.forEach((supplier) => {
      supplier.supplierid = supplier.supplierid.toString();
      supplier.gsid = supplier.gsid.toString();
      dataTmp.push(supplier);
    });
    goodsSuppliers.value = dataTmp;
  });
});
</script>